import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import AddFavourite from "../../utility/js/addFav";
import documentService from "./document-upload-service";
import EncryptUtility from "../../utility/js/encrypt-utility";
export default {
  data: () => ({
    name: "DocumentMastersAccountDetails",
    userId: EncryptUtility.localStorageDecrypt("userID"),
    route: "",
    mainPage: "",
    subPage: "",
    subPageUrl: "",
    appPageName: "",
    pageName: "",
    backSlash: true,
    backSlashParent: true,
    refresh: true,
    totalRecords: 0,
    accountMastersDetails: [],
    searchFilter: "",
    selectedDocumentType: 0,
    documentTypeList: [],
    selectedPersonnel: 0,
    personnelList: [],
    selectedDocumentStatus: 0,
    documentStatusList: [],
    documentApprovedListData: [],
    pageCount: 0,
    page: 1,
    documentApprovedListHeaders: [
      { text: "Document No", value: "document_number", class: "primary customwhite--text" },
      { text: "Title", value: "title", class: "primary customwhite--text" },
      { text: "Document Type", value: "type_name", class: "primary customwhite--text" },
      { text: "Author", value: "author_name", class: "primary customwhite--text" },
      { text: "Account Name", value: "account_name", class: "primary customwhite--text" },      
      { text: "Account Manager", value: "account_manager", class: "primary customwhite--text" },      
      { text: "Manager Approval", value: "is_manager_approved", class: "primary customwhite--text" },
      { text: "Engineer", value: "engineer_name", class: "primary customwhite--text" },
      { text: "Engineer Approval", value: "is_engineer_approved", class: "primary customwhite--text" },
      { text: "Status", value: "status_name", class: "primary customwhite--text", width: "12%"},
      { text: "Applicable Personnel", value: "applicable_personnel", class: "primary customwhite--text", width: "25%" },
      { text: "Action", value: "actions", class: "primary customwhite--text" },
    ],
  }),
  async created() {
    let dataSimple = await AddFavourite.getPageAction(this.userId, "document-approval-list");
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = dataSimple.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
    this.loadDropdowns();
    this.getDocumentData(1);
  },
  methods: {
    //Reset function
    resetFunction() {
      this.totalRecords = 0;
      this.searchFilter = "";
      this.selectedDocumentType = 0;
      this.documentTypeList = [];
      this.selectedPersonnel = 0;
      this.personnelList = [];
      this.selectedDocumentStatus = 0;
      this.documentStatusList = [];
      this.documentApprovedListData = [];
      this.pageCount = 0;
      this.page = 1;
      this.loadDropdowns();
      this.getDocumentData(1);
    },
    async loadDropdowns() {
      let masterObj = {
        pass: 0,
        user_id: parseInt(this.userId),
      };
      let masterData = await documentService.documentLoadMasters("post", masterObj, false);
      if (masterData.message !== "NA") {
        this.documentTypeList = masterData.document_type;
        this.documentStatusList = masterData.document_status;
        this.personnelList = masterData.applicable_personnel;
      }
    },
    //Get data table data
    async getDocumentData(page) {
      let obj = {
        user_id: parseInt(this.userId),
        page_number: page,
        page_size: 20,
        search_string: this.searchFilter,
        account_key: 0,
        type_key: parseInt(this.selectedDocumentType),
        sort_column: "document_id",
        sort_direction: "DESC",
        applicable_personnel_key: parseInt(this.selectedPersonnel),
      };
      let data = await documentService.documentApprovedList("post", obj, false);
      if (data.message !== "NA" && data.length !== 0) {
        this.totalRecords = data[0].total_records;
        this.pageCount = data[0].total_pages;
        const newArr = data.map((obj) => {
          return {
            ...obj,
            applicable_personnel: JSON.parse(obj.applicable_personnel),
          };
        });
        this.documentApprovedListData = newArr;
      } else {
        this.totalRecords = 0;
        this.pageCount = 0;
        this.documentApprovedListData = [];
      }
    },
    //Get Search data
    getSearchData() {
      if (this.searchFilter.length > 3) {
        this.getDocumentData(1);
      }
    },
    // Clear all filters and refresh table
    clearFilters() {
      this.searchFilter = "";
      this.selectedDocumentType = 0;
      this.selectedPersonnel = 0;
      this.selectedDocumentStatus = 0;
      this.getDocumentData(1);
    },
    //View Document
    viewDocument(item) {
      this.$router.push({
        name: "approvalDocumentDetails",
        params: {
          documentID: btoa(item.document_id.toString()),
        },
      });
    },
  },
  components: {
    breadcrumbComp,
  },
};
